<widget-period-indicator
  [currentValue]="currentValue"
  [previousValue]="previousValue"
  [variation]="variation"
  [variationFormat]="variationFormat"
  [invisible]="invisible"
></widget-period-indicator>
